require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-review-of-sigdial-semdial-2017.json") })
        }
      }, "path---posts-review-of-sigdial-semdial-2017");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-review-of-sigdial-semdial-2017!./.cache/json/posts-review-of-sigdial-semdial-2017.json
// module id = 407
// module chunks = 231608221292675